import { inject, Injectable } from '@angular/core';

import { FiReportWidgetDateBase } from '@fi-shared/fi-report-widget/fi-report-widget-date-base';
import { FiOnboardingReportDateType } from '../fi-onboarding-report-enums';
import { Observable, Subject } from 'rxjs';
import { IOnboardingReportWidget } from '../fi-onboarding-report';
import { INameIdObj } from '@fi-app/shared/fi-shared-interfaces';
import { FiTaskReportDateType } from '@fi-app/task-v2/fi-task-v2-report/fi-task-v2-report-enums';
import { AppTextService } from '@fi-app/shared/app-text/app-text.service';
import { DeepReadonly } from '@fi-app/shared/types/deep-readonly';

@Injectable()
export class FiOnboardingReportDateService extends FiReportWidgetDateBase<FiOnboardingReportDateType> {
    private appTextService = inject(AppTextService);

    protected defaultTimePeriodType = FiOnboardingReportDateType.PastWeek;

    private _updateSummary$ = new Subject<IOnboardingReportWidget>();
    get updateSummary$(): Observable<IOnboardingReportWidget> {
        return this._updateSummary$.asObservable();
    }

    updateSummary(widget: IOnboardingReportWidget) {
        this._updateSummary$.next(widget);
    }

    readonly TimeIntervalOptions: DeepReadonly<INameIdObj[]> = [
        {
            Id: FiTaskReportDateType.PastWeek,
            Name: this.appTextService.get('common.last_week'),
        },
        {
            Id: FiTaskReportDateType.PastMonth,
            Name: this.appTextService.get('common.last_month'),
        },
        {
            Id: FiTaskReportDateType.PastQuarter,
            Name: this.appTextService.get('common.last_quarter'),
        },
        {
            Id: FiTaskReportDateType.PastYear,
            Name: this.appTextService.get('common.last_year'),
        },
    ];
}
